export const colorSet = [
  {
    title: "Dark green",
    colors: [
      "#d7e1e0",
      "#0b2019",
      "#0b2019",
      "#d7e1e0",
      "#eaefef",
      "#0b2019",
      "#f4fbfb",
    ],
  },
  {
    title: "Dark purple",
    colors: [
      "#cdc4fe",
      "#cdc4fe",
      "#1c1b21",
      "#eeebff",
      "#101014",
      "#eeebff",
      "#282730",
    ],
  },
  {
    title: "White",
    colors: [
      "#1b3798",
      "#1b3798",
      "#ffffff",
      "#2a3045",
      "#d7dcec",
      "#2a3045",
      "#eff1f8",
    ],
  },
];

export const fonts = [
  {
    name: "Primary",
    value: "Lora",
    provider: "google",
  },
];
